(ns com.theplantscape.plant-web.components.tailwind.forms.login
  (:require
   [com.theplantscape.plant-web.components.forms.core
    :refer [remove-atom-hm!]]
   [com.theplantscape.web-ui.tailwind.form.elements.form
    :refer [get-form-value set-form-value set-form-value-event]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [ui-form-checkbox-fn]]
   [com.theplantscape.web-ui.tailwind.form.elements.input
    :refer [ui-form-password-confirm-input ui-form-submit ui-form-password-input-fn ui-form-input-fn]]
   [reagent.core :as r]))

(defn password-reset-request-form [title cfg]
  (let [form-state (r/atom {:disabled false
                            :mode :login})
        on-submit (fn [e]
                    (.preventDefault e)
                    (swap! form-state assoc :disabled true)
                    ((:on-submit cfg) form-state))]

    (fn [title cfg]
      [:div.min-h-screen.bg-gray-100.flex.flex-col.justify-center.sm:py-12
       [:div.p-10.xs:p-0.mx-auto.md:w-full.md:max-w-md
        [:div.flex
         (when (-> @form-state :disabled)
           [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
            {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
            [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
            [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])
         [:h1.font-bold.text-center.text-2xl.mb-5 title]]
        [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
         [:div.px-5.py-7
          (into [:p] (-> @form-state :errors))
          [:form {:on-submit on-submit}
           [:label.font-semibold.text-sm.text-gray-600.pb-1.block "E-mail"]
           [:input.border.rounded-lg.px-3.py-2.mt-1.mb-5.text-sm.w-full
            {:type "text" :placeholder "user@example.com" :name "user|email" :on-change (:on-change cfg)}]
           [ui-form-submit
            {:label "Request link"
             :disabled (-> @form-state :disabled)}]
           #_[:input.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
              {:type "submit"
               :disabled (-> @form-state :disabled)
               :value "Request password reset link"}]]]
         [:div.py-5
          [:div.grid.grid-cols-2.gap-1
           [:div.text-center.sm:text-left.whitespace-nowrap]
           [:div.text-center.sm:text-right.whitespace-nowrap
            [:div.mx-5.my-5]]]]]

        [:div.py-5
         [:div.grid.grid-cols-2.gap-1
          [:div.text-center.sm:text-left.whitespace-nowrap

           [:button.transition.duration-200.mx-5.px-5.py-4.cursor-pointer.font-normal.text-sm.rounded-lg.text-gray-500.hover:bg-gray-200.focus:outline-none.focus:bg-gray-300.focus:ring-2.focus:ring-gray-400.focus:ring-opacity-50.ring-inset
            [:svg.w-4.h-4.inline-block.align-text-top
             {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor"}
             [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M10 19l-7-7m0 0l7-7m-7 7h18"}]]
            [:span.inline-block.ml-1
             {:on-click #(.back js/history)}
             "Back to homepage"]]]]]]])))

(defn password-reset-form [title values cfg]
  (let [form-state (r/atom {:disabled false
                            :mode :login})
        on-webauth-create (fn [e]
                            (.preventDefault e)
                            ((:on-webauth cfg) values))
        on-submit (fn [e]
                    (.preventDefault e)
                    (swap! form-state assoc :disabled true)
                    ((:on-submit cfg) form-state))]

    (fn [title values cfg]
      [:div.min-h-screen.bg-gray-100.flex.flex-col.justify-center.sm:py-12
       [:div.p-10.xs:p-0.mx-auto.md:w-full.md:max-w-md
        [:div.flex
         (when (-> @form-state :disabled)
           [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
            {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
            [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
            [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])
         [:h1.font-bold.text-center.text-2xl.mb-5 title]]
        [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
         [:div.px-5.py-7
          (into [:p] (-> @form-state :errors))
          [:form {:on-submit on-submit}

           (when (nil? (-> @values :values :user|public-key))
             [:<>
              [:button.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
               {:on-click on-webauth-create}
               "Sign up using Webauth"]

              [ui-form-password-confirm-input
               (r/cursor values [:values :user|password])
               {:name "user|password"
                :label "Password"
                :store-fn (fn set-password-value-reset-public-key [e]
                            (remove-atom-hm! values [:values :user|public-key])
                            ((:on-change cfg) e))}]])

           [ui-form-submit
            {:label "Reset login"
             :disabled (-> @form-state :disabled)}]

           #_[ui-form-submit
              {:label "Reset password"
               :disabled (-> @form-state :disabled)}]

           #_[:input.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
              {:type "submit"
               :disabled (-> @form-state :disabled)
               :value "Reset password"}]]]

         [:div.py-5
          [:div.grid.grid-cols-2.gap-1
           [:div.text-center.sm:text-left.whitespace-nowrap
            [:div.mx-5.my-5]
            #_[:button.transition.duration-200.mx-5.px-5.py-4.cursor-pointer.font-normal.text-sm.rounded-lg.text-gray-500.hover:bg-gray-100.focus:outline-none.focus:bg-gray-200.focus:ring-2.focus:ring-gray-400.focus:ring-opacity-50.ring-inset "test"]]
           [:div.text-center.sm:text-right.whitespace-nowrap]]]]
        [:div.py-5
         [:div.grid.grid-cols-2.gap-1
          [:div.text-center.sm:text-left.whitespace-nowrap
           [:button.transition.duration-200.mx-5.px-5.py-4.cursor-pointer.font-normal.text-sm.rounded-lg.text-gray-500.hover:bg-gray-200.focus:outline-none.focus:bg-gray-300.focus:ring-2.focus:ring-gray-400.focus:ring-opacity-50.ring-inset
            [:svg.w-4.h-4.inline-block.align-text-top
             {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor"}
             [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M10 19l-7-7m0 0l7-7m-7 7h18"}]]
            [:span.inline-block.ml-1
             {:on-click #(.back js/history)}
             "Back to homepage"]]]]]]])))

(defn login-form [title {:keys [set-value get-value] :as cfg}]
  (let [form-state (r/atom {:disabled false :mode :login})
        on-submit (fn [e]
                    (.preventDefault e)
                    (swap! form-state assoc :disabled true)
                    ((:on-submit cfg) form-state))]

    (fn [title cfg]
      [:div.p-10.xs:p-0.mx-auto.md:w-full.md:max-w-md
       [:div.flex
        (when (-> @form-state :disabled)
          [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
           {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
           [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
           [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])
        [:h1.font-bold.text-center.text-2xl.mb-5 title]]
       [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
        [:div.px-5.py-7
         (into [:div] (mapv (fn [error] [:p.bg-white (:msg error)]) (:errors @form-state)))
         [:form {:on-submit on-submit}


          #_[:label.font-semibold.text-sm.text-gray-600.pb-1.block "E-mail"]
          #_[:input.border.rounded-lg.px-3.py-2.mt-1.mb-5.text-sm.w-full
             {:type "text" :placeholder "user@example.com" :name "user|email" :on-change (:on-change cfg)}]

          [ui-form-input-fn
           {:name "user|email"
            :label "E-Mail"
            :placeholder "user@example.com"
            :on-change (:on-change cfg)
            :set-value set-value #_(partial set-form-value-event form-state)
            :get-value get-value #_(partial get-form-value form-state)}]

          #_[:button.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block.mb-4
             {:on-click (:on-webauth cfg)}
             "Login with out a password"]

          [ui-form-password-input-fn
           {:name "user|password"
            :label "Password"
            :on-change (:on-change cfg)
            :set-value set-value #_(partial set-form-value-event form-state)
            :get-value get-value #_(partial get-form-value form-state)}]

          ;; [:label.font-semibold.text-sm.text-gray-600.pb-1.block "Password"]
          ;; [:input.border.rounded-lg.px-3.py-2.mt-1.mb-5.text-sm.w-full
          ;;  {:type "password" :name "user|password" :on-change (:on-change cfg)}]

          [ui-form-checkbox-fn
           {:name "user|remember-me"
            :title "Stay logged in"
            :label "Stay logged in ?"
            :tooltip "Stay logged in ?"
            :default true
            :set-value set-value #_(partial set-form-value form-state)
            :get-value get-value #_(partial get-form-value form-state)}]

          [ui-form-submit
           {:label "Login"
            :disabled (-> @form-state :disabled)}]

          #_[:input.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
             {:type "submit"
              :disabled (-> @form-state :disabled)
              :value "Login"}]]]
        [:div.py-5
         [:div.grid.grid-cols-2.gap-1
          [:div.text-center.sm:text-left.whitespace-nowrap

           [:button.transition.duration-200.mx-5.px-5.pt-2.pb-4.cursor-pointer.font-normal.text-sm.rounded-lg.text-gray-500.hover:bg-gray-100.focus:outline-none.focus:bg-gray-200.focus:ring-2.focus:ring-gray-400.focus:ring-opacity-50.ring-inset
            [:svg.w-4.h-4.inline-block.align-text-top
             {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor"}
             [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"}]]
            [:a {:href (:route-forgot-password cfg)}
             [:span.inline-block.ml-1 "Forgot Password"]]]]

          [:div.text-center.sm:text-right.whitespace-nowrap
           [:div.mx-5]]]]]

       [:div.py-5
        [:div.grid.grid-cols-2.gap-1
         [:div.text-center.sm:text-left.whitespace-nowrap
          [:button.transition.duration-200.mx-5.px-5.py-4.cursor-pointer.font-normal.text-sm.rounded-lg.text-gray-500.hover:bg-gray-200.focus:outline-none.focus:bg-gray-300.focus:ring-2.focus:ring-gray-400.focus:ring-opacity-50.ring-inset
           [:svg.w-4.h-4.inline-block.align-text-top
            {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor"}
            [:path {:stroke-linecap "round" :stroke-linejoin "round" :stroke-width "2" :d "M10 19l-7-7m0 0l7-7m-7 7h18"}]]
           [:a {:href (:route-homepage cfg)}
            [:span.inline-block.ml-1 "Back to homepage"]]]]]]])))
